// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-k_gK","advertDetailHeaderLocation__value":"c-k_gL"};